import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { doc, getDoc, deleteDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { AuthContext } from '../context/auth.context';
import "../css/rutaDetalle.css"

function RutaDetalle() {
    const { isAdmin } = useContext(AuthContext);
    const navigate = useNavigate();
    const { rutaId } = useParams();

    const [ruta, setRuta] = useState(null);
    const [isFetching, setIsFetching] = useState(true);
    const [okMessage, setOkMessage] = useState("");

    useEffect(() => {
        const getRuta = async () => {
            try {
                const rutaRef = doc(db, 'rutas', rutaId);
                const rutaSnap = await getDoc(rutaRef);
                if (rutaSnap.exists()) {
                    setRuta(rutaSnap.data());
                } else {
                    navigate('/error');
                }
            } catch (error) {
                console.error(error);
                navigate('/error');
            } finally {
                setIsFetching(false);
            }
        };
        getRuta();
    }, [rutaId, navigate]);

    const handleDeleteRuta = async () => {
        const result = window.confirm("¿Estás seguro de eliminar esta ruta?");
        if (!result) return;

        try {
            await deleteDoc(doc(db, 'rutas', rutaId));
            setOkMessage("Ruta eliminada correctamente");
            setTimeout(() => navigate('/rutas-bicicleta'), 2000);
        } catch (error) {
            console.error(error);
            navigate('/error');
        }
    };

    if (isFetching) {
        return (
            <div className="loader-container">
                <div className="spinner-border" role="status"></div>
            </div>
        );
    }

    if (!ruta) return <p className="no-results">Ruta no encontrada</p>;

    return (
       <main className="main">
  <div className="page">
    <div className="ruta-detalle-container">
      
      {/* CABECERA: Título con Dancing Script */}
      <header className="ruta-header-centered">
        <h2 className="ruta-title-magic">{ruta.nombre}</h2>
        
        {/* FOTO CENTRADA */}
        <div className="ruta-foto-wrapper-centered">
          <img src={ruta.foto} alt={ruta.nombre} className="ruta-foto-main" />
        </div>

        {/* DETALLES (Stats) CENTRADOS DEBAJO DE LA FOTO */}
        <div className="ruta-stats-strip-centered">
          <div className="stat-item">📏 {ruta.distancia} KM</div>
          <div className={`stat-item dureza-${ruta.dureza}`}>
            ⛰️ {ruta.dureza ? ruta.dureza.toUpperCase() : 'N/A'}
          </div>
          {ruta.modalidad && (
            <div className="stat-item">🚲 {ruta.modalidad.toUpperCase()}</div>
          )}
        </div>
      </header>

      {/* CUERPO: Descripción y Acciones */}
      <div className="ruta-info-card-clean">
        <div className="ruta-descripcion-text">
          {ruta.descripcion}
        </div>

        <div className="ruta-actions-centered">
          <a 
            href={ruta.gpx} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="gpx-btn-action"
          >
            📍 DESCARGAR TRACK GPX
          </a>
        </div>

        {okMessage && <p className="ok-message-centered">{okMessage}</p>}
      </div>

      {/* PANEL ADMIN */}
      {isAdmin && (
        <div className="admin-controls-panel">
          <h4>Configuración de Ruta</h4>
          <div className="admin-btns-row">
            <Link to={`/ruta/${rutaId}/update`}>
              <button className="admin-btn-edit">Actualizar</button>
            </Link>
            <button onClick={handleDeleteRuta} className="admin-btn-del">Eliminar</button>
          </div>
        </div>
      )}
    </div>
    
  </div>
</main>
    );
}

export default RutaDetalle;